var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"font-icon",class:[_vm.isElIcon ? _vm.icon : 'iconfont ' + _vm.icon]})}
var staticRenderFns = []

export { render, staticRenderFns }